import React from 'react';
import PropTypes from 'prop-types';
import { reduxFormPropTypes } from 'constants/propTypes';
import withFormContext from './withFormContext';

function Form(props) {
  const { form, children, ...restProps } = props;
  const { handleSubmit, handleReset } = form;

  return (
    <form {...restProps} onSubmit={handleSubmit} onReset={handleReset} noValidate>
      {children}
    </form>
  );
}

Form.propTypes = {
  form: reduxFormPropTypes.context,
  children: PropTypes.node,
};

export default withFormContext(Form);
